const SEARCH_TYPE = Object.freeze({
  REWARDS_V2: 'rewards-v2',
  DEALS: 'deals',
  REWARDS: 'rewards',
  GIFT_CARDS: 'giftCards',
});

export default SEARCH_TYPE;
